import { render } from "./emoji_reactions.vue?vue&type=template&id=2f762a98"
import script from "./emoji_reactions.js?vue&type=script&lang=js"
export * from "./emoji_reactions.js?vue&type=script&lang=js"

import "./emoji_reactions.vue?vue&type=style&index=0&id=2f762a98&lang=scss"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__